import React from "react";
import { Chip, makeStyles, withStyles } from "@material-ui/core";
import { unitSizeMetadata } from "model/interest/unit-size";
import { extendedStates } from "components/haven-design/state-picker";
import { formatAsCurrency } from "pages/dashboard/utils";
import { Filters } from "./filters-modal";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
    color: "white",
  },
}));

const StyledChip = withStyles({
  root: {
    flex: "none !important",
    margin: 3,
    maxWidth: "calc(100% - 6px)",
    // @ts-ignore
    flexDirection: "row !important",
    color: "white",
    "& .MuiChip-deleteIcon": {
      color: "white",
    },
  },
})(Chip);

const removeState = (filters:Filters, value:string) => ({
  ...filters,
  selectedStates: filters.selectedStates.filter(state => state !== value),
});

const removeCity = (filters:Filters, value:string) => ({
  ...filters,
  selectedCities: filters.selectedCities.filter(city => city !== value),
});

const removeUnitSize = (filters:Filters, value:string) => ({
  ...filters,
  unitSizes: filters.unitSizes.filter(unitSize => unitSize !== value),
});

const FilterChips:React.FC<{
  filters:Filters,
  onChange:(values:Filters) => void,
}> = ({ filters, onChange }) => {
  const classes = useStyles();

  const styleFix:React.CSSProperties = {
  };

  return (<div className={classes.root}>
    {filters.selectedStates.map(state =>
      <StyledChip
        key={state}
        color="primary"
        // @ts-ignore
        label={extendedStates[state]}
        onDelete={() => onChange(removeState(filters, state))}
      />)}
    {filters.selectedCities.map(city =>
      <StyledChip style={styleFix}
        key={city}
        color="primary"
        label={city}
        onDelete={() => onChange(removeCity(filters, city))}
      />)}
    {filters.unitSizes.map(unitSize =>
      <StyledChip style={styleFix}
        key={unitSize}
        color="primary"
        label={unitSizeMetadata.find(data => data.id === unitSize)?.label ?? ""}
        onDelete={() => onChange(removeUnitSize(filters, unitSize))}
      />)}
    {filters.income !== null && <StyledChip
      style={styleFix}
      color="primary"
      label={`${formatAsCurrency(filters.income.toString())} per ${filters.incomeFrequency}`}
      onDelete={() => onChange({ ...filters, income: null })}
    />}
  </div>);
};

export { FilterChips };
